var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',[_c('attachments',{attrs:{"schema":_vm.$schema,"entity-type":_vm.entityType,"entity-id":_vm.procedureId,"show-radio":false,"editable":_vm.editable,"show-add-from-mdok-button":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }